import React, { useState,useEffect } from "react";
import {
  DialogContent,
  CardContent,
  Card,
  makeStyles,
  Button,
  Grid
} from "@material-ui/core";
import Select from "react-select";
import { KisshtDialog } from "components/custom/KisshtDialog";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import Spin from "components/ui/Spin";
import InputField from "components/ui/form/InputField";
import { connect } from "react-redux";
import {
  updatePinCodeList,
  addNewPincode,
  stateDropDwonList,
  cityDropDwonListApi
} from "shared/api/pincodelist";
import { toastError, toastSuccess } from "shared/utils";

export const AddEditPinModel = (props) => {
  const { visible, handleDialogClose,handleDialogClick, data,isEditing} = props;
  let offset = 1;
  const [spinning, setSpinning] = useState(false);
  const [stateDropDownData, setstateDropDownData] = useState([]);
  const [cityDropDownData, setcityDropDownData] = useState([]);
  const [cityMasterData, setcityMasterData] = useState([]);
  
  const useStyle = makeStyles((theme) => ({
    table: {
      marginBottom: "1rem",
    },
    card: {
      "& .MuiCardHeader-root": {
        padding: "12px",
        paddingBottom: 0,
      },
      "& .MuiCardContent-root": {
        padding: 0,
      },
    },
  }));
  const customStyles = {
    control: base => ({
      ...base,
      minHeight: 60,
    })
  };

  let isPurpleActive = [
    { value: 1, label: "Yes" } ,
    { value: 0, label: "No" } 
  ]
  let isActive = [
    { value: "1", label: "Yes" } ,
    { value: "0", label: "No" },
    { value: "2", label : "Conditional"}
  ]
  const pinRegExp = /^.{6,6}$/

  const classes = useStyle();
  const scheme = Yup.object().shape({
    state_reference_number: Yup.string().required("Please enter state"),   
    pincode:  Yup.string().matches(pinRegExp, 'Pincode is not valid'), 
    // pincode: Yup.number().required("Please enter pincode"),
    city_reference_number: Yup.string().required("Please enter city"),
    is_purple_active: Yup.string().required("Please select ispurpleActive"),
    is_active: Yup.string().required("Please select isActive"),
  });

  
  const handleClose = (_) => {
    handleDialogClick(false);
  };
  const getParam = (_) => {
    return `?limit=${4000}&offset=${offset - 1}`;
  }
  const fetchStateDropDownList = async () => {
    setSpinning(true);
    let param = getParam();
    stateDropDwonList(param)
      .then((res) => {
        setSpinning(false);
        if (res.hasOwnProperty("success") && res.success) {
          if (res?.data?.list?.length > 0) {
            let state_data = [];
             for (let i = 0; i < res?.data?.list.length; i++) {
               const el = res?.data?.list[i];
               state_data.push({
                 "label": el.state_name,
                 "value": el.state_reference_number              
               })
             }
            setstateDropDownData(state_data);
          } 
        }
      })
      .catch((error) => {
        setSpinning(false);
      });
  };
 useEffect(() => {
    if (offset === 1) {
      fetchStateDropDownList();
      fetchCityDropDownList();
    }
  }, []);


 useEffect(() => {
  if (
    isEditing &&
    data?.state_reference_number &&
    cityMasterData?.length > 0
  ) {
    const ct = cityMasterData.filter(
      (val) => val?.state_reference_number === data?.state_reference_number
    );
    setcityDropDownData(ct);
  }
}, [isEditing, data, cityMasterData]);


  
 
  const handleBindCity = (state_reference_number)=>{ 
    let ct = cityMasterData.filter((val)=>{ return val?.state_reference_number === state_reference_number })
    setcityDropDownData(ct);
  }

  const fetchCityDropDownList = async () => {
    setSpinning(true);
    let param = getParam();
    cityDropDwonListApi(param)
      .then((res) => {
        setSpinning(false);
        if (res.hasOwnProperty("success") && res.success) {
          if (res?.data?.list?.length > 0) {
            let city_data = [];
             for (let i = 0; i < res?.data?.list.length; i++) {
               const el = res?.data?.list[i];
               city_data.push({
                 "label": el.city_name,
                 "state_reference_number":el.state_reference_number,
                 "value": el.city_reference_number,
               })
             }
            setcityMasterData(city_data);
          } 
        }
      })
      .catch((error) => {
        setSpinning(false);
      });
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    let response = null;
    let payload= {
        "pincode": values?.pincode,
        "state_name": values?.state_name,
        "city_name": values?.city_name,
        "is_active":values?.is_active,
        "is_purple_active": values?.is_purple_active,
        "city_reference_number":values?.city_reference_number,
        "state_reference_number":values?.state_reference_number
      }
      console.log(payload,'payload')
    if (isEditing) {
      let pincodeReferenceNumber = props.data.pincode_reference_number;
    response = await updatePinCodeList(payload,pincodeReferenceNumber);
    } else {
      response = await addNewPincode(payload);
    }
    if (response && response.success) {
      if (isEditing) {
        toastSuccess(`Updated successfully`);
      } else {
        toastSuccess(`Pincode added successfully`);
      }
      handleDialogClose(true);
    } else {
      toastError(response.message);
    }
  };

  return (
    <Spin spinning={spinning}>
      <KisshtDialog
        title={data && isEditing ? "Edit Pincode List" : "Add Pincode List"}
        maxWidth={"sm"}
        open={visible}
        handleClose={handleClose}
      >
        <DialogContent>
          <Card className={classes.card}>
            <CardContent>

            <Formik
                initialValues={{
                  state_name: data && isEditing ? data?.state_name : "",
                  state_reference_number: data && isEditing ? data?.state_reference_number : "",
                  pincode: data && isEditing ? data?.pincode : "",
                  city_name:data && isEditing ? data?.city_name: "",
                  city_reference_number:data && isEditing ? data?.city_reference_number: "",
                  is_purple_active: data && isEditing ? data?.is_purple_active : undefined , 
                  is_active: data && isEditing ? data?.is_active :"",
                  state_reference_number: data && isEditing ? data?.state_reference_number: "",
                  city_reference_number: data && isEditing ? data?.city_reference_number: "",
                }}
                validationSchema={scheme}
                onSubmit={handleSubmit}
              >
                {({ isValid, isSubmitting, values, touched, setFieldValue, handleChange }) => (
                  <Spin spinning={isSubmitting}>
                    <Form>
                         <Field
                          variant="outlined"
                          margin="normal"
                          fullWidth
                          required
                          id="pincode"
                          label="Pincode"
                          placeholder="Please enter pincode"
                          name="pincode"
                          component={InputField}
                          touched={touched}
                          value={values.pincode}
                      /> 
                    <Grid container spacing={1} className="grid-vertical-align-center">
                    <Grid item lg={6} md={6} sm={6} xs={12}>

                        <div style={{paddingBottom: "10px"}}>
                        { data && isEditing ?
                        <label style={{color:"gray",fontSize:"13px"}}>Select State</label> : ""}
                            <Select
                            styles={customStyles}
                            label="State"
                            placeholder="Select State"
                            onChange={selectedOption => {
                              setFieldValue("state_name",selectedOption["label"]);
                              setFieldValue("state_reference_number",selectedOption["value"]);
                              handleBindCity(selectedOption["value"]);  
                            }}
                            value={stateDropDownData.filter(datas => datas?.value === values?.state_reference_number)}
                            isSearchable={true}
                            options={stateDropDownData}
                            name="state_reference_number"
                            id="state_reference_number"
                            required
                            isLoading={false}
                            loadingMessage={() => "Fetching stateData"}
                            noOptionsMessage={() => "No Options Available"}
                          />
                        </div>
                        </Grid>
                        <Grid item lg={6} md={6} sm={6} xs={12}>

                        <div style={{paddingBottom: "10px"}}>
                        {data && isEditing ? 
                        <label style={{color:"gray",fontSize:"13px"}}>Select City</label> : ""}
                            <Select
                            styles={customStyles}
                            label="City"
                            placeholder="Select City"
                            onChange={selectedOption => {
                              setFieldValue("city_name",selectedOption["label"]);
                              setFieldValue("city_reference_number",selectedOption["value"]);
                            }}
                            value={cityDropDownData.filter(datas => datas?.value === values?.city_reference_number)}
                            isSearchable={true}
                            options={cityDropDownData}
                            name="city_reference_number"
                            id="city_reference_number"
                            isLoading={false}
                            loadingMessage={() => "Fetching cityData"}
                            noOptionsMessage={() => "No Options Available"}
                          /> 
                        </div>
                        </Grid>
                        <Grid item lg={6} md={6} sm={6} xs={12}>
                        <div style={{paddingBottom: "30px"}}>
                        {data && isEditing ?
                        <label style={{color:"gray",fontSize:"13px"}}>isPurpleActive</label> : ""}

                          <Select
                            styles={customStyles}
                            label="isPurpleActive"
                            placeholder="Select is Purple Active"
                            onChange={selectedOption => {
                              setFieldValue("is_purple_active",selectedOption["value"]); 
                            }}
                            value={isPurpleActive.filter(datas => datas.value === values.is_purple_active)}
                            isSearchable={true}
                            options={isPurpleActive}
                            name="is_purple_active"
                            id="is_purple_active"
                            isLoading={false}
                            loadingMessage={() => "Fetching isPurpleActive"}
                            noOptionsMessage={() => "isPurpleActive"}
                          />
                        </div>
                        </Grid>
                        <Grid item lg={6} md={6} sm={6} xs={12}>
                        <div style={{paddingBottom: "30px"}}>
                        {data && isEditing ?
                          <label style={{color:"gray",fontSize:"13px"}}>isActive</label> :""}
                          <Select
                            styles={customStyles}
                            label="isActive"
                            placeholder="Select is Active"
                            onChange={selectedOption => {
                              setFieldValue("is_active",selectedOption["value"]);  
                            }}
                            value={isActive.filter(datas => datas.value === values.is_active)}
                            isSearchable={true}
                            options={isActive}
                            name="is_active"
                            id="is_active"
                            isLoading={false}
                            touched={touched}

                            loadingMessage={() => "Fetching isActive"}
                            noOptionsMessage={() => "isActive"}
                          />
                        </div>
                        </Grid>
                        </Grid>
                      <div style={{ textAlign: "center" }}>
                        <Button
                          disabled={isSubmitting || !isValid}
                          type="submit"
                          size="large"
                          variant="contained"
                          color="primary"
                          className="mb-4 justify-center common_kissht_btn"
                        >
                          Submit
                        </Button>
                      </div>
                    </Form>
                  </Spin>
                )}
              </Formik>
            </CardContent>
          </Card>
        </DialogContent>
      </KisshtDialog>
    </Spin>
  );
};
const mapStateToProps = ({ auth }) => ({
  user: auth.user,
});
export default connect(mapStateToProps, null)(AddEditPinModel);
